<template>
  <div class="row">
    <div class="mx-auto col-md-12">
      <div class="card p-3 mb-3">
        <div class="card-body">
          <b-card class="mb-3" header="Gerar Parcela para Beneficiários">
            <b-row>
              <b-col>
                <b-form-group label="CPF" label-size="sm">
                  <b-form-input size="sm" v-model="cpf_requerente">
                  </b-form-input>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row class="mt-2">
              <b-col class="text-right">
                <b-button variant="primary" @click="listar">
                  <font-awesome-icon :icon="['fas', 'search']" /> Pesquisar
                </b-button>
              </b-col>
            </b-row>
          </b-card>
          <div class="card">
            <div class="card-body">
              <b-alert variant="warning" :show="!data_pagamento">
                <h6 class="alert-heading">
                  <font-awesome-icon :icon="['fas', 'exclamation-triangle']" />
                  &nbsp;Não foi encontrada nenhuma próxima data de pagamento do
                  benefício.
                </h6></b-alert
              >
              <b-alert variant="success" :show="data_pagamento"
                >Próxima data de pagamento do benefício:
                <strong>{{
                  $helpers.formatDateHourToDate(data_pagamento)
                }}</strong></b-alert
              >
              <b-card no-body>
                <b-card-header size="sm">
                  <div class="float-left">
                    <b-input-group
                      prepend="Quantidade por página"
                      class="mb-2 mr-sm-2 mb-sm-0"
                    >
                      <b-form-select v-model="tabela.perPage">
                        <option :value="10">10</option>
                        <option :value="20">20</option>
                        <option :value="30">30</option>
                        <option :value="40">40</option>
                        <option :value="50">50</option>
                      </b-form-select>
                    </b-input-group>
                  </div>
                  <div class="float-right">
                    <b-button
                      variant="outline-secondary"
                      title="Gerar Parcela"
                      @click="gerarParcela()"
                      :disabled="!data_pagamento"
                    >
                      <font-awesome-icon
                        :icon="['fa', 'file-invoice-dollar']"
                        class="mr-1"
                      />
                      Gerar Parcela
                    </b-button>
                  </div>
                </b-card-header>
                <b-table
                  no-provider-paging
                  small
                  bordered
                  responsive
                  :current-page="tabela.currentPage"
                  :empty-text="tabela.emptyText"
                  :fields="tabela.fields"
                  :items="tabela.items"
                  :per-page="tabela.perPage"
                  :show-empty="tabela.showEmpty"
                  :striped="tabela.striped"
                >
                  <template v-slot:head(selecionar)>
                    <b-tr>
                      <b-form-checkbox
                        v-model="selected"
                        @change="selecionarTodos()"
                      ></b-form-checkbox>
                    </b-tr>
                  </template>
                  <template v-slot:cell(selecionar)="data">
                    <b-form-checkbox
                      @change="selecionarLinha(data.item)"
                      v-model="data.item.selected"
                    ></b-form-checkbox>
                  </template>
                </b-table>
                <template v-slot:footer>
                  <b-row>
                    <b-col>
                      <b-input-group prepend="Quantidade de Registros">
                        <b-input
                          style="font-weight: bold"
                          class="text-right"
                          disabled
                          :value="tabela.items.length"
                        ></b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-input-group
                        prepend="Quantidade de Registros Selecionados"
                      >
                        <b-input
                          disabled
                          style="font-weight: bold"
                          class="text-right text-success"
                          :value="listaBeneficiariosSelecionados.length"
                        ></b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row>
                    <b-col>
                      <b-input-group
                        prepend="Quantidade de Registros com Pagamentos Gerados"
                      >
                        <b-input
                          disabled
                          style="font-weight: bold"
                          class="text-right text-info"
                          :value="qtd_pagamentos_gerados"
                        ></b-input>
                      </b-input-group>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col>
                      <b-pagination
                        align="right"
                        :total-rows="tabela.totalRows"
                        v-model="tabela.currentPage"
                        :per-page="tabela.perPage"
                      >
                      </b-pagination>
                    </b-col>
                  </b-row>
                </template>
              </b-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";

export default {
  data() {
    return {
      numero_parcelas_beneficio: null,
      qtd_pagamentos_gerados: 0,
      data_pagamento: null,
      selected: false,
      cpf_requerente: "",
      listaBeneficiariosSelecionados: [],
      tabela: {
        currentPage: 1,
        items: [],
        fields: [
          {
            key: "selecionar",
            thStyle: "width:140px",
            label: "",
          },
          {
            key: "cpf_requerente",
            label: "CPF",
            class: "text-center",
          },
          {
            key: "nome_completo",
            label: "Nome",
            class: "text-center",
          },
        ],
        showEmpty: true,
        emptyText: "Nenhum registro encontrado",
        striped: true,
        perPage: 10,
        totalRows: 0,
      },
      hoje: moment().format("YYYY-MM-DD"),
    };
  },

  methods: {
    selecionarTodos() {
      this.listaBeneficiariosSelecionados = [];
      this.tabela.items.forEach((element) => {
        if (this.selected) {
          element.selected = true;
          this.selecionarLinha(element);
        } else {
          element.selected = false;
          this.selecionarLinha(element);
        }
      });
    },

    selecionarLinha(item) {
      if (item.selected) {
        item._rowVariant = "success";
        this.listaBeneficiariosSelecionados.push(item);
      } else {
        var index = this.listaBeneficiariosSelecionados.findIndex(
          (element) => element.control === item.control
        );
        this.listaBeneficiariosSelecionados.splice(index, 1);
        item._rowVariant = null;
      }
    },

    listar() {
      this.$api
        .get(
          `familias/beneficiarios-gerar-parcela?cpf_requerente=${this.cpf_requerente}&data_pagamento=${this.data_pagamento}`
        )
        .then((response) => {
          if (response.status == 200) {
            this.tabela.items = [];
            this.qtd_pagamentos_gerados = response.data.dados.qtdPagamentos;
            response.data.dados.beneficiarios.forEach((element) => {
              element.qtd_total_parcelas =
                element.beneficio_familia.controle_pagamento.length;
              if (element.qtd_total_parcelas < this.numero_parcelas_beneficio) {
                element.selected = false;
                element._rowVariant = null;
                element.control = Math.random();
                element.beneficio_familia_id = parseInt(
                  element.beneficio_familia_id
                );
                this.tabela.items.push(element);
              }
            });
            this.tabela.totalRows = response.data.dados.beneficiarios.length;
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },

    gerarParcela() {
      const h = this.$createElement;
      const messageVNode = h("div", { class: ["foobar"] }, [
        h("p", [
          "Mês/Ano Referência: ",
          h(
            "strong",
            moment(this.data_pagamento, "YYYY-MM-DD").format("MM/YYYY")
          ),
        ]),
        h("p", [
          "Quantidade de Beneficiários selecionados: ",
          h("strong", this.listaBeneficiariosSelecionados.length),
        ]),
        h("p", { class: ["text-left"] }, [
          h(
            "p",
            "Deseja realmente gerar parcela para o(s) beneficiário(s) selecionado(s)?"
          ),
        ]),
      ]);
      if (this.listaBeneficiariosSelecionados.length != 0) {
        this.$helpers
          .modalConfirmacao(
            this,
            "Gerar Parcela Beneficiários",
            messageVNode,
            "md",
            "primary",
            "SIM"
          )
          .then((value) => {
            if (value) {
              this.$api
                .post(`pagamentos/gerar-parcela`, {
                  items: this.listaBeneficiariosSelecionados,
                  data_pagamento: this.data_pagamento,
                })
                .then((response) => {
                  if (response.status == 200) {
                    this.formAlterado = false;
                    this.selected = false;
                    this.tabela.items = [];
                    this.listaBeneficiariosSelecionados = [];
                    this.qtd_pagamentos_gerados =
                      response.data.dados.qtdPagamentos;
                    response.data.dados.beneficiarios.forEach((element) => {
                      element.qtd_total_parcelas =
                        element.beneficio_familia.controle_pagamento.length;
                      element.selected = false;
                      element._rowVariant = null;
                      element.control = Math.random();
                      element.beneficio_familia_id = parseInt(
                        element.beneficio_familia_id
                      );
                      this.tabela.items.push(element);
                    });
                    this.tabela.totalRows =
                      response.data.dados.beneficiarios.length;

                    this.$helpers.showToast(
                      this,
                      "Sucesso",
                      response.data.message,
                      "success"
                    );
                  }
                })
                .catch((error) => {
                  if (error.response.data) {
                    this.$helpers.showToast(
                      this,
                      "Erro",
                      error.response.data.message,
                      " danger"
                    );
                  }
                });
            }
          });
      }
    },

    obterDataPagamento() {
      return this.$api
        .get(`parametros-pagamento/data-pagamento`)
        .then((response) => {
          if (response.status == 200) {
            if(this.hoje < response.data.dados.dataPagamento.data_pagamento){
              this.data_pagamento =
              response.data.dados.dataPagamento.data_pagamento;
            }
            this.numero_parcelas_beneficio = parseInt(
              response.data.dados.beneficio.numero_parcelas
            );
          }
        })
        .catch((error) => {
          if (error.response.data) {
            this.$helpers.showToast(
              this,
              "Erro",
              error.response.data.message,
              "danger"
            );
          }
        });
    },
  },

  async mounted() {
    await this.obterDataPagamento();
    this.listar();
  },
};
</script>

<style scoped>
</style>
